import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/GrayPillsIllustration.tsx
const GrayPillsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "gray-pills.svg",
		alt: t("illustration.imageAlt.pills")
	});
};

//#endregion
export { GrayPillsIllustration };